export default __webpack_public_path__ + "static/media/OnePaper.a53c8f8c.jpg";